let tableHeaderElement, tableFooterElement, tableFixed;
let previousRequest = null;

function loadingElements(){
    tableHeaderElement = document.getElementById('tableHeader');
    tableFixed = document.getElementById('tableBody');
    tableFooterElement = document.getElementById('tableFooter');
}

function bindingScroll(tablebody){
    tableHeaderElement ? tableHeaderElement.scrollLeft = tablebody.scrollLeft : '';
    tableFooterElement ? tableFooterElement.scrollLeft = tablebody.scrollLeft : '';
}

function generateTable(selfRef){
    setTimeout(function(){

        loadingElements();

        let tablebody = document.getElementById('tableBody');

        tablebody.onscroll = function(){
            bindingScroll(this);
        }

        let headerRows = document.querySelectorAll('#tableHeader .table .table_row');

        for(let i=0;i<headerRows.length;i++){

            let hr_Height = headerRows[i].offsetHeight;
            let hr_fc_Height = headerRows[i].firstChild.offsetHeight;
            
            if(hr_Height > hr_fc_Height){
                headerRows[i].firstChild.style.height = hr_Height+1+"px";
            }
            else{
                headerRows[i].style.height = (hr_fc_Height-1)+"px";
            }

        }

        let bodyRows = document.querySelectorAll('#tableBody .table .table_row');
        for(let i=0;i<bodyRows.length;i++){

            let br_Height = bodyRows[i].offsetHeight;
            let br_fc_Height = bodyRows[i].firstChild.offsetHeight;
            
            if(br_Height > br_fc_Height){
                bodyRows[i].firstChild.style.height = br_Height+1+"px";
            }
            else{
                bodyRows[i].style.height = (br_fc_Height-1)+"px";
            }
        }

        let footerRows = document.querySelectorAll('#tableFooter .table .table_row');
        for(let i=0;i<footerRows.length;i++){
            
            let fr_Height = footerRows[i].offsetHeight;
            let fr_fc_Height = footerRows[i].firstChild.offsetHeight;
            
            if(fr_Height > fr_fc_Height){
                footerRows[i].firstChild.style.height = fr_Height+1+"px";
            }
            else{
                footerRows[i].style.height = (fr_fc_Height-1)+"px";
            }
        }

        let tabledbody = document.querySelector('#tableBody');
        tabledbody.style.paddingTop = headerRows[0].offsetHeight+1+"px";

        selfRef.hideLoading();

    }, 500)
}

function formatDate(date_obj){
    return date_obj.getFullYear() + "-" + ("0" + (date_obj.getMonth()+1)).slice(-2) + "-" + ("0" + date_obj.getDate()).slice(-2);
}

export const reportTableMixin =  {

    methods: {

        fn_generateTable: function(){
            generateTable(this);
        },

        // fn_getTimeSpan: function(type){
        //     let dateObj = {};
            
        //     if(type=='month'){
        //         let now = new Date();
        //         let lastday  = new Date(now.getFullYear(), now.getMonth()+1, 0);
        //         let firstday = new Date(lastday.getFullYear(), lastday.getMonth(), 1);
        //         dateObj.startDate = formatDate(firstday);
        //         dateObj.endDate = formatDate(now);
        //     }
        //     else if(type=='year'){
        //         let now = new Date()
        //         let currentmonth = now.getMonth()+1;
        //         let fy;
        //         currentmonth > 3 ? fy = now.getFullYear() : fy = now.getFullYear()-1;
        //         let firstday = new Date(fy, 3, 1);
        //         dateObj.startDate = formatDate(firstday);
        //         dateObj.endDate = formatDate(now);
        //     }
        //     else if(type=='endDate'){
        //         dateObj.startDate = null;
        //         dateObj.endDate = new Date();
        //     }
        //     else if(type=='currentDate'){
        //         dateObj.startDate = this.$moment(new Date()).startOf('day');
        //         dateObj.endDate = this.$moment(new Date()).endOf('day');
        //     }
        //     else{
        //         dateObj.startDate = new Date();
        //         dateObj.endDate = new Date();
        //     }

        //     return dateObj;
        // }

        fn_getTimeSpan: function(type, value, year){
            let dateObj = {};

            let minSelectionDate = new Date(this.$root.minDateSelection);
            let currentDate = new Date();
            let currentMonth = currentDate.getMonth() + 1;
            let thisFiscalYear = currentMonth<=3 ? currentDate.getFullYear() : currentDate.getFullYear() + 1;

            if(type=='monthly'){

                let now = null;

                // value == month number
                // if(value<=3){
                //     now = new Date("2023/"+value);
                // }
                // else{
                //     now = new Date();
                // }
                if(value<=3){
                    now = new Date((year+1)+"/"+value);
                }
                else{
                    now = new Date(year+"/"+value);
                }

                // let now = new Date();
                // last date of the month
                let endDate  = new Date(now.getFullYear(), value, 0);
                // first date of the month
                let startDate = new Date(now.getFullYear(), value-1, 1);

                let sDate = null;
                if(startDate.getTime() > minSelectionDate.getTime()){
                    sDate = startDate;
                }
                else{
                    sDate = minSelectionDate;
                }

                dateObj.startDate = formatDate(sDate);
                dateObj.endDate = formatDate(endDate);
            }
            
            // for current month / this month
            else if(type=='month'){
                let now = new Date();
                let endDate  = new Date(now.getFullYear(), now.getMonth()+1, 0);
                let startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1);

                // let minSelectionDate = new Date(this.$root.minDateSelection);

                let sDate = null;
                if(startDate.getFullYear() ==  minSelectionDate.getFullYear()){
                    if(startDate.getMonth()+1 > minSelectionDate.getMonth()+1){
                        sDate = startDate;
                    }
                    else{
                        sDate = minSelectionDate
                    }
                }
                else{
                    // sDate = minSelectionDate
                    sDate = startDate
                }

                // dateObj.startDate = formatDate(startDate);
                dateObj.startDate = formatDate(sDate);
                dateObj.endDate = formatDate(endDate);
                // dateObj.endDate = formatDate(now);
            }
            else if(type=='previousMonth'){
                let now = new Date();
                let sDate = new Date(now.getFullYear(), now.getMonth()-1, 1);
                let endDate  = new Date(now.getFullYear(), now.getMonth(), 0);
                dateObj.startDate = formatDate(sDate);
                dateObj.endDate = formatDate(endDate);
            }
            else if(type=='quarterly'){
                // let now = new Date();
                let now = null;

                // value == month number
                // if(value<=3){
                //     now = new Date("2023/"+value);
                // }
                // else{
                //     now = new Date("2022/"+value);
                // }
                if(value<=3){
                    now = new Date((year+1)+"/"+value);
                }
                else{
                    now = new Date(year+"/"+value);
                }

                let quarter = Math.floor((now.getMonth() / 3));
                let firstDate = new Date(now.getFullYear(), quarter * 3, 1);
                let endDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + 3, 0);

                // let minSelectionDate = new Date(this.$root.minDateSelection);

                if(firstDate.getTime() < minSelectionDate.getTime()){
                    dateObj.startDate = formatDate(minSelectionDate); 
                }
                else{
                    dateObj.startDate = formatDate(firstDate);
                }
                
                dateObj.endDate = formatDate(endDate);
            }
            else if(type=='quarter'){
                let now = new Date();
                let quarter = Math.floor((now.getMonth() / 3));
                let firstDate = new Date(now.getFullYear(), quarter * 3, 1);
                let endDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + 3, 0);

                // let minSelectionDate = new Date(this.$root.minDateSelection);

                if(firstDate.getTime() < minSelectionDate.getTime()){
                    dateObj.startDate = formatDate(minSelectionDate); 
                }
                else{
                    dateObj.startDate = formatDate(firstDate);
                }
                
                dateObj.endDate = formatDate(endDate);
            }
            else if(type=='year'){
                // let firstday = new Date(this.$root.minDateSelection);
                let endDate = new Date(this.$moment(new Date(thisFiscalYear+"/03/31")).endOf('day'));
                if(this.$root.fn_getMinSelectionDate() < new Date((thisFiscalYear-1)+"/04/01")){
                    dateObj.startDate = formatDate(new Date((thisFiscalYear-1)+"/04/01"));
                }
                else{
                    dateObj.startDate = formatDate(this.$root.fn_getMinSelectionDate());
                }
                // dateObj.startDate = formatDate(this.$root.fn_getMinSelectionDate());
                dateObj.endDate = formatDate(endDate);
            }
             else if(type=='fiscal_year'){
                // let firstday = new Date(this.$root.minDateSelection);
                let endDate = new Date(this.$moment(new Date((year+1)+"/03/31")).endOf('day'));
                // dateObj.startDate = this.formatDate(minSelectionDate);
                let startDate = null;

                let openingYear = new Date(this.$root.minDateSelection).getFullYear();
                let openingMonth = new Date(this.$root.minDateSelection).getMonth() + 1;
                
                let minDateYear = openingMonth < 4 ? openingYear - 1 : openingYear;

                if(minDateYear == year){
                    startDate = new Date(this.$moment(this.$root.minDateSelection));
                }
                else if(minDateYear < year){
                    startDate = new Date(this.$moment(new Date(year+"/04/01")));
                }

                dateObj.startDate = formatDate(startDate);
                dateObj.endDate = formatDate(endDate);
            }
            else if(type=='alltime'){
                // let firstday = new Date(this.$root.minDateSelection);
                let maxDateYear = new Date(this.$root.maxDateSelection).getFullYear();
                let year = maxDateYear > thisFiscalYear ? maxDateYear : thisFiscalYear;
                let endDate = new Date(this.$moment(new Date(year+"/03/31")).endOf('day'));
                dateObj.startDate = formatDate(minSelectionDate);
                dateObj.endDate = formatDate(endDate);
            }
            else if(type=='endDate'){
                dateObj.startDate = null;
                dateObj.endDate = new Date();
            }
            else if(type=='currentDate'){
                dateObj.startDate = this.$moment(new Date()).startOf('day');
                dateObj.endDate = this.$moment(new Date()).endOf('day');
            }
            else if(type=='previousDate'){
                let now = new Date();
                let yesterday = now.setDate(now.getDate() - 1);
                dateObj.startDate = this.$moment(yesterday).startOf('day');
                dateObj.endDate = this.$moment(yesterday).endOf('day');
            }
            else{
                dateObj.startDate = new Date();
                dateObj.endDate = new Date();
            }

            let filterStartDate = new Date(dateObj.startDate);
            let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);

            if(filterStartDate.getTime() < openingDate.getTime()){
                dateObj.startDate = formatDate(openingDate);

                if(type=='month'){
                    // last date of month
                    dateObj.endDate = new Date(openingDate.getFullYear(), openingDate.getMonth()+1, 0);
                }
            }

            dateObj.startDate = dateObj.startDate ? this.$root.fn_getLocalDateFormat(dateObj.startDate) : null;
            dateObj.endDate = this.$root.fn_getLocalDateFormat(dateObj.endDate);

            if(new Date(dateObj.endDate) < new Date(this.$root.CurrentBusiness.OpeningDate)){
                this.showToast("Selected period is not applicable!");
                dateObj.startDate = dateObj.endDate;
            }

            if(type == 'currentDate'){
                this.$root.dataObj.selectedPeriod = "Today";
            }
            else if(type == 'previousDate'){
                this.$root.dataObj.selectedPeriod = "Yesterday";
            }
            else if(type == 'month' || type == 'monthly' || type == 'previousMonth'){
                // this.selectedPeriod = "This Month";
                this.$root.dataObj.selectedPeriod = this.$moment(dateObj.startDate).format('MMM, YYYY');
            }
            else if(type == 'quarter' || type == 'quarterly' || type == 'fiscal_year'){
                // this.selectedPeriod = "This Quarter";
                this.$root.dataObj.selectedPeriod = this.$moment(dateObj.startDate).format('MMM') + ' - ' + this.$moment(dateObj.endDate).format('MMM');
            }
            else if(type == 'year'){
                this.$root.dataObj.selectedPeriod = "This Year";
            }
            else if(type == 'alltime'){
                this.$root.dataObj.selectedPeriod = "All Time";
            }
            else{
                this.$root.dataObj.selectedPeriod = null;
            }

            // let filterStartDate = new Date(dateObj.startDate);
            // let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);

            // if(filterStartDate.getTime() < openingDate.getTime()){
            //     dateObj.startDate = formatDate(openingDate);

            //     if(type=='month'){
            //         // last date of month
            //         dateObj.endDate = new Date(openingDate.getFullYear(), openingDate.getMonth()+1, 0);
            //     }
            // }

            // // dateObj.startDate = this.$root.fn_getLocalDateFormat(dateObj.startDate);
            // dateObj.startDate = dateObj.startDate ? this.$root.fn_getLocalDateFormat(dateObj.startDate) : null;
            // dateObj.endDate = this.$root.fn_getLocalDateFormat(dateObj.endDate);

            return dateObj;
        }      

    }
}


// WEBPACK FOOTER //
// ./src/components/newreports/report_table_mixin.js